function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { string, oneOf, node } from 'prop-types';
import { styled } from '@mui/material/styles';
import Icon from '@mui/material/Icon';
import { getIconSizes } from '../internals/utils';
const StyledIcon = styled(Icon, {
  shouldForwardProp: prop => prop !== 'fontSize'
})(_ref => {
  let {
    fontSize,
    theme: {
      spacing
    }
  } = _ref;
  const sizes = getIconSizes(spacing);
  const iconSize = sizes[fontSize] || sizes.medium;
  return {
    '&.material-icons': {
      ...iconSize.icon
    }
  };
});
const SovosIcon = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    fontSize = 'medium',
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    fontSize: fontSize,
    className: clsx('sovosIcon', className),
    ref: ref
  }, rest), children);
});
SovosIcon.propTypes = {
  /**
   * The content of the icon.
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Editable size of the icon. If undefined, it will maintain the selected
   * `size` prop above.
   */
  fontSize: oneOf(['inherit', 'small', 'medium', 'large'])
};
SovosIcon.baseComponent = {
  name: 'Icon',
  link: 'icon/'
};
export default SovosIcon;